/** "Super Single" in the hero title, with a circled TM mark. */
export default function SuperSingleLockup() {
  return (
    <span className="relative inline-block whitespace-nowrap pr-[0.42em] font-permanent-marker text-[1.1em] font-normal normal-case leading-[0.9] tracking-[-0.025em] text-teal-500 max-[680px]:text-[1em]">
      Super Single
      <sup className="absolute right-0 top-[0.03em] inline-flex size-[1.6em] items-center justify-center rounded-full border-2 border-current font-figtree text-[0.17em] font-extrabold leading-none tracking-[-0.04em]">
        TM
      </sup>
    </span>
  );
}
